import React, { useEffect, useState } from 'react';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import TableComponent from '../../../components/DataTable/TableComponent';

const ClickLocationTable = () => {
    const [selectedFilter, setSelectedFilter] = useState('COUNTRY')
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(5);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    const [loadingState, setLoadingState] = useState(true)

    const columns = [
        { name: "#ID", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Location", selector: (row) => row?.channel_name, grow: 3.4, cell: (row) => (
                <p className="mb-0.5 font-semibold text-sm text-primary">{row?.name || "N/A"}</p>
            )
        }, {
            name: "Clicks + Scans", center: "true", selector: (row) => row?.title, cell: (row) => (
                <p className="mb-0">{row?.count}</p>
            )
        }, {
            name: "%", center: "true", selector: (row) => row?.category, cell: (row) => (
                <p className="mb-0">{row?.percentage || '0%'}</p>
            )
        },
    ];

    async function getTableData() {
        setLoadingState(true);
        let resp = await getApi(urlApi.getLocationData + "?page=1&limit=5");
        setLoadingState(false);
        if (resp.responseCode === 200) {
            setTableData({
                data: selectedFilter == "COUNTRY" ? resp.data?.countryData?.items : resp.data?.cityData?.items,
                totalCount: selectedFilter == "COUNTRY" ? resp.data?.countryData?.count : resp.data?.cityData?.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    useEffect(() => {
        getTableData();
    }, [selectedFilter])

    return (
        <div className='p-2 bg-[#fff] rounded-lg h-full'>
            <div className='flex items-center gap-3 justify-between mb-2'>
                <div>
                    <p className='mb-0 text-md font-bold text-[var(--grey)]'>Clicks + scans by top locations (overall)</p>
                    <p className='mb-0 text-xs text-gray-400'>Including Pages and Business Cards sub links </p>
                </div>
                <div className="flex outline outline-[#383c5120] outline-[1px] p-1 rounded-lg gap-2">
                    <button className={`${selectedFilter == "COUNTRY" ? 'bg-primary text-white' : 'bg-transparent'} px-3 py-1 rounded-lg font-semibold text-xs`} onClick={() => setSelectedFilter('COUNTRY')}>Countries</button>
                    <button className={`${selectedFilter == "CITY" ? 'bg-primary text-white' : 'bg-transparent'} px-3 py-1 rounded-lg font-semibold text-xs`} onClick={() => setSelectedFilter('CITY')}>Cities</button>
                </div>
            </div>
            <TableComponent
                isHeader={true}
                columns={columns}
                data={tableData?.data}
                totalRows={tableData?.totalCount}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => { }}
                handlePerRowsChange={(newPerPage, page) => { }} />
        </div>
    )
}

export default ClickLocationTable